import { defineMessages } from 'react-intl';
import globalMessages from 'messages';

const messages = {
  ...globalMessages,
  ...defineMessages({
  'remindModalTitle': '您确定发送POPO服务号提醒消息给相关操作人员么？',
  'remindTimeTip': `{duration}分钟后可再次提醒`,
  'projectIdIllegal': '项目ID不合法',
}),
};

export default messages;
